module.exports = __webpack_public_path__ + "img/page-08.3781595d.jpg";